export var SourceStatus;
(function (SourceStatus) {
    SourceStatus["CONNECTED"] = "CONNECTED";
    SourceStatus["HIDDEN"] = "HIDDEN";
    SourceStatus["SKIPPED"] = "SKIPPED";
})(SourceStatus || (SourceStatus = {}));
